import { useToast } from '@chakra-ui/react';
import React, { createContext, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axiosInstance from '../../../../../api/axiosInstance';
import { parse, format } from 'date-fns';
import { extractYouTubeVideoId } from '../../../../../misc/extractYouTubeVideoId';
import { saveAs } from 'file-saver';

export type OptionType = {
  label: string;
  value: string;
};

export interface FileAssesment {
  id: number;
  assessment_id: number;
  path_file: string;
  nama_file: string;
  mime_type: string;
  created_at: string;
  updated_at: string;
}

export const OptionJenisPemateri = [
    { label: 'ASN', value: 'ASN' },
    { label: 'NON ASN', value: 'NON_ASN' },
    { label: 'EKSTERNAL', value: 'EKSTERNAL' }
];

interface IState {
  state: {
    isOpenModal: boolean;
    title: string;
    linkStreaming: string;
    pathFile: File | null;
    titleAssesment: string;
    descriptionAssesment: string;
    pathFileAssesment: File[] | FileAssesment[];
    linkDrive: string;
    paketSoalId: string;
    quizDuration: number;
    category: OptionType | null;
    youtubeVideoSelected: OptionType | null;
    urlTautan: string;
    videoTautan: OptionType | null;
    listVideoTautan: OptionType[];
    pdf: File | null;
    isLoadingPost: boolean;
    url: string;
    keyword: string;
    isLoadingData: boolean;
    listData: [];
    listSpeakers: OptionType[];
    speakerSelected: OptionType | null;
    page: number;
    perPage: number;
    totalListData: number;
    hasQuiz: boolean;
    hasAssesment: boolean;
    mode: string;
    listCategory: OptionType[];
    modalQuizMode: string;
    modalAssesmentMode: string;
    startDate: string;
    startTime: string;
    jenisPemateriSelected: OptionType | null;
    keywordPemateri: string;
    jenjang: string;
    kelas: string;
    mataPelajaranId: string;
    jenjangList: any[];
    kelasList: any[];
    mataPelajaranList: any[];
    isOpenModalTteSertifikat: boolean;
    ttePengetahuanId: number | null;
    ttePemateriId: number | null;
    isTteUlang: boolean;
    accountTTESelected: OptionType | null;
    isLoadingTTEPemateri: boolean;
    isLoadingGenerateExcel: boolean;
    isLoadingDownloadExcel: boolean;
    urlManagementPengetahuan: string;
    isGenerateJobRunning : boolean;
    generatePengetahuanId: number | null;
  };
  disptach: {
    setPengetahuanKontenPemateri: Function;
    postData: Function;
    fetchData: Function;
    clearState: Function;
    setPathFileAssesment: Function;
    getDetailKontenPemateri: Function;
    handleOptionPemateri: Function;
    getJenjang: Function;
    getKelas: Function;
    getMataPelajaran: Function;
    generateExcel: Function;
    downloadExcel: Function;
    tteSertifikatPemateri: Function;
  };
}

const initialState: IState = {
  state: {
    isOpenModal: false,
    title: '',
    linkStreaming: '',
    pathFile: null,
    titleAssesment: '',
    descriptionAssesment: '',
    pathFileAssesment: [],
    linkDrive: '',
    paketSoalId: '',
    quizDuration: 0,
    category: null,
    youtubeVideoSelected: null,
    urlTautan: '',
    videoTautan: null,
    pdf: null,
    isLoadingPost: false,
    url: 'management_content/pengetahuan_materi',
    keyword: '',
    isLoadingData: false,
    listData: [],
    listSpeakers: [],
    speakerSelected: null,
    page: 1,
    perPage: 10,
    totalListData: 0,
    hasAssesment: false,
    hasQuiz: false,
    mode: 'view',
    listCategory: [
      { value: 'video', label: 'Video' },
      { value: 'pdf', label: 'PDF' },
    ],
    listVideoTautan: [
      { value: 'video', label: 'Video Dari Youtube Pintar' },
      { value: 'tautan', label: 'Tautan Video' },
    ],
    modalQuizMode: '',
    modalAssesmentMode: '',
    startDate: '',
    startTime: '',
    jenisPemateriSelected: null,
    keywordPemateri: '',
    jenjang: '',
    kelas: '',
    mataPelajaranId: '',
    jenjangList: [],
    kelasList: [],
    mataPelajaranList: [],
    isOpenModalTteSertifikat: false,
    ttePengetahuanId: null,
    ttePemateriId: null,
    isTteUlang: false,
    accountTTESelected: null,
    isLoadingTTEPemateri: false,
    isLoadingGenerateExcel: false,
    isLoadingDownloadExcel: false,
    urlManagementPengetahuan: 'management_content/pengetahuan',
    isGenerateJobRunning: false,
    generatePengetahuanId: null
  },
  disptach: {
    setPengetahuanKontenPemateri: () => {},
    postData: () => {},
    fetchData: () => {},
    clearState: () => {},
    setPathFileAssesment: () => {},
    getDetailKontenPemateri: () => {},
    handleOptionPemateri: () => {},
    getJenjang: () => {},
    getKelas: () => {},
    getMataPelajaran: () => {},
    generateExcel: () => {},
    downloadExcel: () => {},
    tteSertifikatPemateri: () => {},
  },
};

const Context = createContext<IState>(initialState);
const { Provider: ManajemenPengetahuanKontenPemateriProvider } = Context;

const ManajemenPengetahuanKontenPemateriController: React.FC = ({
  children,
}) => {
  const [state, setState] = useState<IState>(initialState);
  const toast = useToast();
  const history = useHistory();

  const {
    title,
    linkStreaming,
    pathFile,
    linkDrive,
    paketSoalId,
    quizDuration,
    titleAssesment,
    descriptionAssesment,
    url,
    category,
    youtubeVideoSelected,
    pdf,
    speakerSelected,
    keyword,
    page,
    perPage,
    listCategory,
    urlTautan,
    listVideoTautan,
    pathFileAssesment,
    hasQuiz,
    hasAssesment,
    startDate,
    startTime,
    jenisPemateriSelected,
    keywordPemateri,
    jenjang,
    kelas,
    mataPelajaranId,
    urlManagementPengetahuan,
  } = state.state;

  const setPengetahuanKontenPemateri = (
    key: keyof IState['state'],
    value: any
  ) => {
    setState((prevState) => ({
      ...prevState,
      state: {
        ...prevState.state,
        [key]: value,
      },
    }));
  };

  const fetchData = async (id: number) => {
    setPengetahuanKontenPemateri('isLoadingData', true);

    try {
      const { data } = await axiosInstance.get(`${urlManagementPengetahuan}/${id}/pemateri`, {
        params: {
          page,
          per_page: perPage,
          search: keyword,
        },
      });

      setPengetahuanKontenPemateri(
        'listData',
        data.data ?? []
      );

      setPengetahuanKontenPemateri(
        'totalListData',
        data.total
      );

    } catch (error) {
      throw error;
    } finally {
      setPengetahuanKontenPemateri('isLoadingData', false);
    }
  };

  const handleOptionPemateri = async () => {
    try {
      const response = await axiosInstance.get('/pemateri', {
        params: {
          jenis: jenisPemateriSelected?.value,
          search: keywordPemateri,
        },
      });

      const dataSpeaker = response.data?.data.map((item) => ({
        label: item.nama,
        value: item.id,
      }));
      setPengetahuanKontenPemateri('listSpeakers', dataSpeaker);
    } catch (error) {
        const title = error.response?.data?.message ||
          'Terjadi kesalahan saat mengambil data';
        toast({
            title: 'Error',
            description: title,
            status: 'error',
            position: 'top-right',
            duration: 3000,
            isClosable: true,
        });
    }
  }

  const getDetailKontenPemateri = async (id: number) => {
    setPengetahuanKontenPemateri('isLoadingData', true);
    try {
      const { data } = await axiosInstance.get(`${url}/${id}`);

      const { pengetahuanMateri, pemateri } = data?.data;

      const speakerSelected = pemateri
        .filter((item) => item.id === pengetahuanMateri?.pemateri_id)
        .map((item) => ({
          label: item.nama,
          value: item.id,
        }))[0];

      const jenisPemateriSelected = pemateri
        .filter((item) => item.id === pengetahuanMateri?.pemateri_id)
        .map((item) => {
            let label;
            if (item.jenis === 'ASN') {
              label = 'ASN';
            } else if (item.jenis === 'NON_ASN') {
              label = 'NON ASN';
            } else if (item.jenis === 'EKSTERNAL') {
              label = 'EKSTERNAL';
            }
            return {
              label,
              value: item.jenis,
            };
      })[0];

      setPengetahuanKontenPemateri('speakerSelected', speakerSelected);
      setPengetahuanKontenPemateri('title', pengetahuanMateri?.judul);
      setPengetahuanKontenPemateri('jenisPemateriSelected', jenisPemateriSelected);
      
      if (pengetahuanMateri?.jenjang) {
        setPengetahuanKontenPemateri('jenjang', pengetahuanMateri.jenjang);
      }
      if (pengetahuanMateri?.kelas) {
        setPengetahuanKontenPemateri('kelas', pengetahuanMateri.kelas);
      }
      if (pengetahuanMateri?.mata_pelajaran_id) {
        setPengetahuanKontenPemateri('mataPelajaranId', pengetahuanMateri.mata_pelajaran_id);
      }

      if (pengetahuanMateri?.tanggal_mulai) {
        const startDateMateri = parse(
          pengetahuanMateri?.tanggal_mulai,
          'd MMMM yyyy',
          new Date()
        );
        const convertStartDate = format(startDateMateri, 'yyyy-MM-dd');
        setPengetahuanKontenPemateri('startDate', convertStartDate);
      }

      if (pengetahuanMateri?.waktu_mulai) {
        const startTimeMateri = parse(
          pengetahuanMateri?.waktu_mulai,
          'hh:mm a',
          new Date()
        );
        const convertStartTime = format(startTimeMateri, 'HH:mm');
        setPengetahuanKontenPemateri('startTime', convertStartTime);
      }

      setPengetahuanKontenPemateri(
        'linkStreaming',
        pengetahuanMateri?.link_streaming
      );
      const categorySelected = listCategory.find(
        (item) => item.value === pengetahuanMateri?.category
      );
      const videoTautanSelected = listVideoTautan.find(
        (item) => item.value === pengetahuanMateri?.videoTautan
      );
      setPengetahuanKontenPemateri('category', categorySelected);
      setPengetahuanKontenPemateri('videoTautan', videoTautanSelected);

      if (categorySelected?.value === 'video') {
        setPengetahuanKontenPemateri(
          'youtubeVideoSelected',
          pengetahuanMateri?.path_file
        );
        setPengetahuanKontenPemateri(
          'urlTautan',
          `https://www.youtube.com/watch?v=${pengetahuanMateri?.path_file}`
        );
      } else {
        setPengetahuanKontenPemateri('pdf', pengetahuanMateri?.path_file);
      }

      if (pengetahuanMateri?.has_quiz) {
        setPengetahuanKontenPemateri('hasQuiz', pengetahuanMateri?.has_quiz);
        setPengetahuanKontenPemateri(
          'paketSoalId',
          pengetahuanMateri?.paket_soal_id
        );
        setPengetahuanKontenPemateri(
          'quizDuration',
          pengetahuanMateri?.durasi_quiz
        );
      }

      if (pengetahuanMateri?.has_assessment) {
        setPengetahuanKontenPemateri(
          'hasAssesment',
          pengetahuanMateri?.has_assessment
        );
        setPengetahuanKontenPemateri(
          'titleAssesment',
          pengetahuanMateri?.pengetahuan_assessment?.judul
        );
        setPengetahuanKontenPemateri(
          'descriptionAssesment',
          pengetahuanMateri?.pengetahuan_assessment?.keterangan
        );

        const updatedPathFilesAssesment =
          pengetahuanMateri?.pengetahuan_assessment?.assessment_files.map(
            (item) => {
              const { nama_file, ...rest } = item;
              return {
                name: nama_file,
                ...rest,
              };
            }
          );

        const hasLInkDrive = updatedPathFilesAssesment?.find(
          (item) => item?.link_drive !== null
        );

        setPengetahuanKontenPemateri(
          'pathFileAssesment',
          updatedPathFilesAssesment
        );

        setPengetahuanKontenPemateri(
          'linkDrive',
          hasLInkDrive?.link_drive ?? ''
        );
      }
    } catch (error) {
      throw error;
    } finally {
      setPengetahuanKontenPemateri('isLoadingData', false);
    }
  };

  const clearState = () => {
    setPengetahuanKontenPemateri('isOpenModal', false);
    setPengetahuanKontenPemateri('title', '');
    setPengetahuanKontenPemateri('category', null);
    setPengetahuanKontenPemateri('videoTautan', null);
    setPengetahuanKontenPemateri('youtubeVideoSelected', null);
    setPengetahuanKontenPemateri('pdf', null);
    setPengetahuanKontenPemateri('hasAssesment', false);
    setPengetahuanKontenPemateri('hasQuiz', false);
    setPengetahuanKontenPemateri('paketSoalId', null);
    setPengetahuanKontenPemateri('quizDuration', 0);
    setPengetahuanKontenPemateri('titleAssesment', '');
    setPengetahuanKontenPemateri('descriptionAssesment', '');
    setPengetahuanKontenPemateri('pathFileAssesment', []);
    setPengetahuanKontenPemateri('speakerSelected', null);
    setPengetahuanKontenPemateri('linkStreaming', '');
    setPengetahuanKontenPemateri('linkDrive', '');
    setPengetahuanKontenPemateri('jenisPemateriSelected', null);
  };

  // Helper function to show error toasts
  const showErrorToast = (title: string, description?: string) => {
    toast({
      title,
      description,
      status: 'error',
      position: 'top-right',
      duration: 3000,
      isClosable: true,
    });
  };

  // Combined function to validate both quiz and assessment fields
  const validateQuizAndAssessment = () => {
    const validationErrors: string[] = [];

    // Quiz validation
    if (hasQuiz) {
      if (!paketSoalId) {
        validationErrors.push('Paket soal ID tidak boleh kosong');
      }
      if (!quizDuration || quizDuration <= 0) {
        validationErrors.push('Durasi kuis harus lebih dari 0');
      }
    }

    // Assessment validation
    if (hasAssesment) {
      if (!titleAssesment) {
        validationErrors.push('Judul assignment tidak boleh kosong');
      }
      if (!descriptionAssesment) {
        validationErrors.push('Deskripsi assignment tidak boleh kosong');
      }
      if (!linkDrive) {
        validationErrors.push('Link assignment tidak boleh kosong');
      }
      if (pathFileAssesment.length === 0) {
        validationErrors.push('Bahan tugas tidak boleh kosong');
      }
    }

    // Show all collected validation errors
    validationErrors.forEach((message) => showErrorToast('Error', message));

    if (validationErrors.length > 0) {
      return false;
    }
    return true;
  };

  const postData = async (id: number, idPemateri: number | null = null) => {
    // Validate both quiz and assessment fields
    const validate = validateQuizAndAssessment();

    if (!validate) {
      return;
    }

    setPengetahuanKontenPemateri('isLoadingPost', true);

    const formData = new FormData();
    formData.append('pengetahuan_id', id.toString());

    if (jenisPemateriSelected) {
      formData.append('jenis_pemateri', jenisPemateriSelected?.value)
    }
 
    if (speakerSelected) {
      formData.append('pemateri_id', speakerSelected?.value);
    }

    formData.append('judul', title);
    
    // default value
    if (jenjang) {
      formData.append('jenjang', jenjang);
    }
    if (kelas) {
      formData.append('kelas', kelas);
    }
    if (mataPelajaranId) {
      formData.append('mata_pelajaran_id', mataPelajaranId);
    }
    
    if (startDate) {
      formData.append('tanggal_mulai', startDate);
    }
    if (startTime) {
      formData.append('waktu_mulai', startTime);
    }
    if (linkStreaming) {
      formData.append('link_streaming', linkStreaming);
      formData.append('category', 'streaming');
    }
    if (paketSoalId && hasQuiz) {
      formData.append('paket_soal_id', paketSoalId);
      formData.append('durasi_quiz', quizDuration.toString());
    }

    if (hasAssesment) {
      formData.append('judul_asesmen', titleAssesment);
      formData.append('keterangan_asesmen', descriptionAssesment);
      formData.append('link_drive', linkDrive);

      if (pathFileAssesment.length) {
        pathFileAssesment.forEach((file, index) => {
          if (file instanceof File) {
            formData.append(`path_file_assessment[${index}]`, file);
          } else {
            formData.append(`path_file_assessment[${index}]`, file.path_file);
          }
        });
      }
    }

    if (category) {
      formData.append('category', category.value);
      if (urlTautan && category.value === 'video') {
        const videoId = extractYouTubeVideoId(urlTautan);
        if (!videoId && category.value === 'video') {
          toast({
            title: 'Invalid URL',
            description: 'Link video tidak valid',
            status: 'error',
            position: 'top-right',
            duration: 3000,
            isClosable: true,
          });
        }

        if (videoId && category.value === 'video') {
          formData.append('path_file', videoId);
        }
      }
      if (youtubeVideoSelected && category.value === 'video') {
        if (typeof youtubeVideoSelected === 'string') {
          formData.append('path_file', youtubeVideoSelected);
        } else {
          formData.append('path_file', youtubeVideoSelected.value);
        }
      }
      if (pdf && category.value === 'pdf') {
        formData.append('path_file', pdf);
      }
    }

    if (pathFile) {
      formData.append('path_file', pathFile);
    }

    const urlAction = idPemateri === null ? url : `${url}/${idPemateri}`;

    try {
      const { data } = await axiosInstance.post(urlAction, formData);

      if (data.code === 200) {
        toast({
          title:
            data.message ??
            'Penegetahuan konten pemateri baru berhasil ditambahkan',
          status: 'success',
          position: 'top-right',
          duration: 3000,
          isClosable: true,
        });
        clearState();
        if (idPemateri) {
          history.push(`/admin/manajemen_pengetahuan/${id}`);
        }
        fetchData(id);
      }
    } catch (error) {
      const responseData = error.response?.data;
      const titleMessage = responseData.message;
      if (responseData.code === 422) {
        Object.keys(responseData.errors).forEach((key) => {
          responseData.errors[key].forEach((errorMessage) => {
            toast({
              title: titleMessage,
              description: errorMessage,
              status: 'error',
              position: 'top-right',
              duration: 3000,
              isClosable: true,
            });
          });
        });
      }

      toast({
        title: titleMessage,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setPengetahuanKontenPemateri('isLoadingPost', false);
    }
  };

  const generateExcel = async (id) => {
    setPengetahuanKontenPemateri('isLoadingGenerateExcel', true);
    setPengetahuanKontenPemateri('isGenerateJobRunning', true);

    try{
      const response = await axiosInstance.get(`${urlManagementPengetahuan}/${id}/pemateri/excel/generate`);

      toast({
          title: response?.data?.message ?? 'Proses generate sedang berjalan',
          status: 'success',
          position: 'top-right',
          duration: 3000,
          isClosable: true,
      });
    } catch (error) {
      setPengetahuanKontenPemateri('isGenerateJobRunning', false);
      const title = error.response?.data?.message || 'Terjadi kesalahan saat mengirim data'
      toast({
        title: 'Error',
        description: title,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setPengetahuanKontenPemateri('isLoadingGenerateExcel', false);
    }
  }

  const downloadExcel = async (id) => {
    setPengetahuanKontenPemateri('isLoadingDownloadExcel', true);
    
    try{
      const response = await axiosInstance.get(`${urlManagementPengetahuan}/${id}/pemateri/excel/download`);

      if (response.status === 200) {
        saveAs(
          response.data.data.path_file_url,
          response.data.data.file_name
        );
        toast({
            title: response?.data?.message ?? 'Berhasil! Excel telah didownload.',
            status: 'success',
            position: 'top-right',
            duration: 3000,
            isClosable: true,
        });
      }
    } catch (error) {
      const title = error.response?.data?.message || 'Terjadi kesalahan saat mengirim data'
      toast({
        title: 'Error',
        description: title,
        status: 'error',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setPengetahuanKontenPemateri('isLoadingDownloadExcel', false);
    }
  }

  const tteSertifikatPemateri = async () => {
    const {
      ttePengetahuanId,
      ttePemateriId,
      isTteUlang,
      accountTTESelected,
    } = state.state;

    if (!ttePengetahuanId || !ttePemateriId) {
      showErrorToast(
        'Data tidak lengkap',
        'ID pengetahuan atau pemateri tidak ditemukan pada baris ini'
      );
      return;
    }
    if (!accountTTESelected) {
      showErrorToast('Data tidak lengkap', 'Pilih akun TTE terlebih dahulu');
      return;
    }

    setPengetahuanKontenPemateri('isLoadingTTEPemateri', true);

    try {
      const formData = new FormData();
      formData.append('akun_tte_id', String((accountTTESelected as any).value));

      const action = isTteUlang ? 'regenerate' : 'generate';
      const { data } = await axiosInstance.post(
        `management_content/pengetahuan/${ttePengetahuanId}/pemateri/${ttePemateriId}/sertifikat/${action}`,
        formData
      );

      toast({
        title:
          data?.message ??
          `Berhasil ${isTteUlang ? 'regenerate' : 'generate'} sertifikat pemateri`,
        status: 'success',
        position: 'top-right',
        duration: 3000,
        isClosable: true,
      });

      setPengetahuanKontenPemateri('isOpenModalTteSertifikat', false);
      setPengetahuanKontenPemateri('accountTTESelected', null);
      setPengetahuanKontenPemateri('ttePengetahuanId', null);
      setPengetahuanKontenPemateri('ttePemateriId', null);
      setPengetahuanKontenPemateri('isTteUlang', false);

      fetchData(ttePengetahuanId);
    } catch (error: any) {
      const msg =
        error?.response?.data?.message ||
        'Terjadi kesalahan saat melakukan TTE sertifikat';
      showErrorToast('Error', msg);
    } finally {
      setPengetahuanKontenPemateri('isLoadingTTEPemateri', false);
    }
  };

  const setPathFileAssesment = (files: File[]) => {
    setPengetahuanKontenPemateri('pathFileAssesment', files);
  };

  const getJenjang = async () => {
    try {
      const { data } = await axiosInstance.get('/jenjang');
      setPengetahuanKontenPemateri('jenjangList', data.data);
    } catch (error) {
      console.log('error get jenjang:', error);
    }
  };

  const getKelas = async (jenjang: string) => {
    try {
      const { data } = await axiosInstance.get('/kelas', {
        params: { jenjang },
      });
      setPengetahuanKontenPemateri('kelasList', data.data);
    } catch (error) {
      console.log('error get kelas:', error);
    }
  };

  const getMataPelajaran = async (jenjang: string) => {
    try {
      const { data } = await axiosInstance.get('/mata_pelajaran', {
        params: { jenjang },
      });
      setPengetahuanKontenPemateri('mataPelajaranList', data.data);
    } catch (error) {
      console.log('error get mata pelajaran:', error);
    }
  };

  return (
    <ManajemenPengetahuanKontenPemateriProvider
      value={{
        state: state.state,
        disptach: {
          setPengetahuanKontenPemateri,
          postData,
          fetchData,
          clearState,
          setPathFileAssesment,
          getDetailKontenPemateri,
          handleOptionPemateri,
          getJenjang,
          getKelas,
          getMataPelajaran,
          generateExcel,
          downloadExcel,
          tteSertifikatPemateri,
        },
      }}
    >
      {children}
    </ManajemenPengetahuanKontenPemateriProvider>
  );
};

export const useManajemenPengetahuanKontenPemateriContext = () => {
  return useContext(Context);
};

export default ManajemenPengetahuanKontenPemateriController;
